/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepLogBase } from './AutoTestStepLogBase';
const CustomOutputLogBaseParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['stdout', codecString],
    ['stderr', codecString],
    ['exitCode', codecNumber, 'exit_code'],
    ['timeSpend', parsers.duration, 'time_spend'],
]), AutoTestStepLogBase);
export class CustomOutputLogBase extends AutoTestStepLogBase {
    static decode(input) {
        return CustomOutputLogBaseParser.decode(input).map(res => new CustomOutputLogBase(res));
    }
    static unsafeDecode(input) {
        return CustomOutputLogBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CustomOutputLogBaseParser.encode(data);
    }
    static schema() {
        return CustomOutputLogBaseParser.schema();
    }
}
